export default __webpack_public_path__ + "static/media/card-blog13.322a00b5.jpg";